import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationRitualsData } from './Data';

export interface IntegrationRitualsState extends BaseIntegrationState {
  endpoint?: string;
}

export class IntegrationRitualsModel extends BaseIntegration<IntegrationRitualsData, IntegrationRitualsState> {
  parse(data: IntegrationRitualsData) {
    super.parse(data);
    this.state.endpoint = data.settings?.endpoint;
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/custom/rituals/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Ani Mikova';
  }
}
